var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon refresh",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.933 0a1.066 1.066 0 0 0-1.067 1.067v2.47a7.232 7.232 0 0 0-12.747 2 1.067 1.067 0 0 0 2.03.656 5.1 5.1 0 0 1 9-1.4h-1.48a1.067 1.067 0 1 0 0 2.133h4.267A1.066 1.066 0 0 0 16 5.867v-4.8A1.066 1.066 0 0 0 14.933 0zm-.74 9.12a1.066 1.066 0 0 0-1.343.686 5.1 5.1 0 0 1-9 1.394h1.48a1.067 1.067 0 1 0 0-2.133H1.067A1.066 1.066 0 0 0 0 10.133v4.8a1.067 1.067 0 0 0 2.133 0v-2.47a7.207 7.207 0 0 0 12.717-2 1.012 1.012 0 0 0-.657-1.343z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f0f831b1cc64047a0dcc21f65289788e.svg";
export { ForwardRef as ReactComponent };